import {connect} from 'react-redux';

import {setCurrentFolderId, setSelectedEvidenceIds} from '../../../state/evidence/actions';
import {getCurrentFolderId, getSelectedEvidenceIds} from '../../../state/evidence/selectors';
import {TRootState} from '../../../state/store';

import EvidenceBaseController from './evidence-base.controller';

const mapStateToProps = (state: TRootState) => ({
  currentFolderId: getCurrentFolderId(state),
  selectedEvidenceIds: getSelectedEvidenceIds(state),
});

const mapDispatchToProps = {
  setCurrentFolderId,
  setSelectedEvidenceIds,
};

const EvidenceBase = connect(mapStateToProps, mapDispatchToProps)(EvidenceBaseController);

export default EvidenceBase;
